const menuItems = {
  items: [
    {
      id: 'pages',
      title: 'Sidebar Menu',
      type: 'group',
      icon: 'icon-pages',
      children: [
        // {
        //   id: 'dashboard ',
        //   title: 'Dashboard ',
        //   type: 'item',
        //   url: '/sample-page',
        //   icon: 'feather icon-home'
        // },
        {
          id: 'users',
          title: 'Manage User ',
          type: 'item',
          url: '/users/userList',
          icon: 'feather icon-user'
        },
        {
          id: 'serviceproviders',
          title: 'Manage Service Providers',
          type: 'item',
          url: '/service-providers',
          icon: 'feather icon-settings'
        },
        {
          id: 'business',
          title: 'Manage Business',
          type: 'item',
          url: '/business',
          icon: 'feather icon-briefcase'
        },
        {
          id: 'category',
          title: 'Manage category',
          type: 'item',
          url: '/category',
          icon: 'feather icon-layers'
        },
        {
          id: 'booking',
          title: 'Manage Booking',
          type: 'item',
          url: '/manage-booking',
          icon: 'feather icon-calendar'
        }
        // {
        //   id: 'promocode',
        //   title: 'Promo Code',
        //   type: 'item',
        //   url: '/promo/list',
        //   icon: 'feather icon-command'
        // },
        // {
        //   id: 'locations',
        //   title: 'Locations Details',
        //   type: 'item',
        //   url: '/location/locationdetails',
        //   icon: 'feather icon-map-pin'
        // },
        // {
        //   id: 'helpSupport',
        //   title: 'Help and Support',
        //   type: 'item',
        //   classes: 'nav-item',
        //   url: '/help-support',
        //   icon: 'feather icon-message-circle'
        // },
        // {
        //   id: 'splashscreens',
        //   title: 'Splash Screen ',
        //   type: 'item',
        //   url: '/splashScreens/splashScreenList',
        //   icon: 'feather icon-smartphone'
        // },
        // {
        //   id: 'message',
        //   title: 'Message',
        //   type: 'item',
        //   classes: 'nav-item',
        //   url: '/message',
        //   icon: 'feather icon-message-circle'
        // }
        // {
        //   id: 'help-request',
        //   title: 'Help Requests ',
        //   type: 'item',
        //   url: '/help-request/request-list',
        //   icon: 'feather icon-message-circle'
        // },
        // {
        //   id: 'driver-registration-request',
        //   title: 'Driver Registration Requests ',
        //   type: 'item',
        //   url: '/driver-request/pending-registration-request',
        //   icon: 'feather icon-message-circle'
        // },
        // {
        //   id: 'driver-edit-request',
        //   title: 'Driver Edit Requests ',
        //   type: 'item',
        //   url: '/driver-request/pending-edit-request',
        //   icon: 'feather icon-message-circle'
        // }
        // {
        //   id: 'auth',
        //   title: 'Authentication',
        //   type: 'collapse',
        //   icon: 'feather icon-lock',
        //   children: [
        //     {
        //       id: 'signup-1',
        //       title: 'Sign up',
        //       type: 'item',
        //       url: '/auth/signup-1',
        //       target: true,
        //       breadcrumbs: false
        //     },
        //     {
        //       id: 'signin-1',
        //       title: 'Sign in',
        //       type: 'item',
        //       url: '/auth/signin-1',
        //       target: true,
        //       breadcrumbs: false
        //     },
        //     {
        //       id: 'reset-password-1',
        //       title: 'Reset Password',
        //       type: 'item',
        //       url: '/auth/reset-password-1',
        //       target: true,
        //       breadcrumbs: false
        //     },
        //     {
        //       id: 'change-password',
        //       title: 'Change Password',
        //       type: 'item',
        //       url: '/auth/change-password',
        //       target: true,
        //       breadcrumbs: false
        //     },
        //     {
        //       id: 'profile-settings',
        //       title: 'Profile Settings',
        //       type: 'item',
        //       url: '/auth/profile-settings',
        //       target: true,
        //       breadcrumbs: false
        //     }
        //   ]
        // },
        // {
        //   id: 'maintenance',
        //   title: 'Maintenance',
        //   type: 'collapse',
        //   icon: 'feather icon-sliders',
        //   children: [
        //     {
        //       id: 'error',
        //       title: 'Error',
        //       type: 'item',
        //       url: '/maintenance/error',
        //       target: true,
        //       breadcrumbs: false
        //     },
        //     {
        //       id: 'coming-soon',
        //       title: 'Coming Soon',
        //       type: 'item',
        //       url: '/maintenance/coming-soon',
        //       target: true,
        //       breadcrumbs: false
        //     },
        //     {
        //       id: 'offline-ui',
        //       title: 'Offline UI',
        //       type: 'item',
        //       url: '/maintenance/offline-ui',
        //       target: true,
        //       breadcrumbs: false
        //     }
        //   ]
        // }
      ]
    }
    // {
    //   id: 'support',
    //   title: 'Support',
    //   type: 'group',
    //   icon: 'icon-support',
    //   children: [
    //     {
    //       id: 'sample-page',
    //       title: 'Sample Page',
    //       type: 'item',
    //       url: '/sample-page',
    //       classes: 'nav-item',
    //       icon: 'feather icon-sidebar'
    //     },
    //     {
    //       id: 'documentation',
    //       title: 'Documentation',
    //       type: 'item',
    //       icon: 'feather icon-book',
    //       classes: 'nav-item',
    //       url: 'https://codedthemes.gitbook.io/datta/',
    //       target: true,
    //       external: true
    //     }
    //   ]
    // }
  ]
};

export default menuItems;
